export const SPREADSHEET_TYPES = new Map<number, string>([
  [2, 'alumni'],
  [3, 'faculty'],
  [4, 'research'],
]);
